/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FormAuditUpdateResponseDto } from '../../models/form-audit-update-response-dto';

export interface BulkUpdateFormStatus$Params {
  reasonCodeId: string;
  body: Array<string>;
}

export function bulkUpdateFormStatus(
  http: HttpClient,
  rootUrl: string,
  params: BulkUpdateFormStatus$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<Array<FormAuditUpdateResponseDto>>> {
  const rb = new RequestBuilder(rootUrl, bulkUpdateFormStatus.PATH, 'put');
  if (params) {
    rb.path('reasonCodeId', params.reasonCodeId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<FormAuditUpdateResponseDto>>;
    })
  );
}

bulkUpdateFormStatus.PATH = '/auditing/bulk/forms/status/{reasonCodeId}';
